export default {
  storage: (filename: string) => {
    const base = import.meta.env.VITE_BASE_STORAGE
    return String(new URL(filename, base))
  },
}